import { Component, OnInit, Input } from '@angular/core';
import { Note } from '../note'
import { NoteService } from '../note.service'
import { UtilsService } from '../utils.service'
import { RuntimeService } from '../runtime.service'
import { DbRecord } from '../db-record'
import { Topic } from '../topic'

@Component({
  selector: 'app-note-box',
  templateUrl: './note-box.component.html',
  styleUrls: ['./note-box.component.css']
})
export class NoteBoxComponent implements OnInit {
  @Input() note: Note
  @Input() dbRecord: DbRecord
  @Input() topic: Topic

  isOwner: boolean
  isEditMode = false
  isRemoveMode = false
  editText: string

  constructor(
    private utils: UtilsService,
    private ns: NoteService,
    private rs: RuntimeService
  ) {

  }

  ngOnInit() {
    if (this.topic)
      this.note = this.rs.currentProject
      .getTopicDbRecordNote(this.dbRecord.id, this.topic.id)
    else
      this.note = this.rs.currentProject.getNote(this.dbRecord.id)
  }

  get buttonLabel() {
    if (this.topic)
      return 'topic note'
    return 'note'
  }

  get isDbRecordNote() {
    return !!this.dbRecord
  }

  get text() {
    if (!this.note)
      return ''
    return this.note.text.replace(/\n/g, '<br>')
  }

  get date() {
    if (!this.note || !this.note.date)
      return ""
    return this.note.date.toUTCString()
  }


  switchEditMode() {
    this.isEditMode = !this.isEditMode
    if (this.isEditMode)
      this.editText = this.note.text
    if (!this.isEditMode && this.note.isNew)
      this.note = null
  }

  switchRemoveMode() {
    this.isRemoveMode = !this.isRemoveMode
  }


  createNote() {
    this.note = this.ns.newNote(this.dbRecord, this.topic)
    this.switchEditMode()
  }

  save() {
    if (this.editText.trim() == '') {
      let obs = this.ns.delete(this.note)
      obs.subscribe((x) => {
        if (x['isSuccess'])
          this.note = null
        this.isEditMode = false
      })
      return
    }

    this.note.text = this.editText
    let obs = this.ns.save(this.note)
    obs.subscribe((x) => {
      this.isEditMode = false
    })
  }


}



// WEBPACK FOOTER //
// ./src/app/note-box/note-box.component.ts